export { ContactAdmin } from './ContactAdmin'
export {Home} from './Home'
export {IDsIFound} from './IDsIFound'
export {Profile} from './Profile'
export {Search} from './Search'
export {IDDetail} from './IDDetail'
export {UploadID} from './UploadID'
export {UserClaims} from './UserClaims'
export {ClaimPage} from './ClaimPage'